import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Control
name: Control
category: React - Bulma
---

A `Control` component based on Bulma `.control`. This is to be used in forms
inside of a `Field` component.

See [Bulma Documentation](http://bulma.io/documentation/form/general/#form-control) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                    |Type            | Default Value             | Required?     |
|-----------------|------------------------------------------------|----------------|---------------------------|---------------|
| hasIconsLeft    | If an IconWrapper is present on the left.      | boolean        | false                     | no            |
| hasIconsRight   | If an IconWrapper is present on the right.     | boolean        | false                     | no            |
| isExtended      | If the input should take the entire width.     | boolean        | false                     | no            |

```html_example
  <form>
    <Field>
      <Control>
        <Input name="example" type="text" onChange={onChangeHandler} />
      </Control>
    </Field>
  </form>
```
*/

/**
* @TODO Add support for icons
*/
function Control(props) {
  const {
    className, children, hasIconsLeft, hasIconsRight, isExpanded, ...rest
  } = props

  const classes = [
    'control',
    hasIconsLeft ? 'has-icons-left' : '',
    hasIconsRight ? 'has-icons-right' : '',
    isExpanded ? 'is-expanded' : '',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}


Control.defaultProps = {
  hasIconsLeft: false,
  hasIconsRight: false,
  isExpanded: false,
}

Control.propTypes = {
  // Control has an `<IconWrapper isLeft />` child.
  hasIconsLeft: PropTypes.bool,
  // Control has an `<IconWrapper isRight />` child.
  hasIconsRight: PropTypes.bool,
  // Control/input should fill width.
  isExpanded: PropTypes.bool,
}

export default Control
